import React, { useState, useEffect } from "react";
//import MetaTags from "react-meta-tags";
/* import { Helmet } from "react-helmet"; */
import {
  BrowserRouter as Router,
  Switch,
  Route,
  /*  Link,
  NavLink,
  Redirect,
  useParams, */
} from "react-router-dom";
import { useTranslation } from "react-i18next";

/* import "../scss/AppDashboard.scss"; */
import "../scss/AppDashboard.scss";

import ProjectDetailView from "./views/ProjectDetailView";

//import LanguageSelector from "./LanguageSelector";
import BudgetForm from "./forms/PopUpForm"; // FORM para orçamentos
import AppMenu from "./AppMenu"; // MENU da App
import AppFooter from "./AppFooter"; // FOOTER da App
import StickyFilterMenu from "./FiltersAndOrders";

// ------------------------------------------------------- Views
// home
import Home from "./views/Home";
// serviços
import ServicesView from "./views/ServicesView";
// estufas
import GreenHouseListView from "./views/GreenHouseListView"; //--> Listagem de estufas
import ProductDetailView from "./views/ProductDetailView"; //--> Listagem de estufas
import GreenHouseServiceDetailView from "./views/GreenHouseServiceDetailView";

// automatismos
import AutomatismsView from "./views/AutomatismsView";
// produtos
import ProductListlView from "./views/ProductListView"; //<-- listagem de produtos de cada familia de produto

// projectos
import ProjectsView from "./views/ProjectsView";
// UNIVERSO PRILUX
import About from "./views/AboutView";
// prilux
// globais
// equipa
// qualidade
// sinergias
// notícia

// notícia detalhe
import NewsDetailView from "./views/NewsDetailView";

// PROJETOS E Downloads
import ProjectsAndDownloads from "./Jumbotron";

// contacts
import Contacts from "./views/ContactsView";

//downloads
import DownloadsView from "./views/DownloadsView";

// pesquisa (resultado)
import SearchProductView from "./views/SearchProductView";

// loja
import StoreHomeView from "./views/StoreHomeView";

// Politica de privacidade
import RGPD from "./views/RGPD"; // RGPD

//Projetos Financiados
import FundedProjectsView from "./views/FundedProjectsView";
// .------------------------------------------------------ Views end

// ------------------------------------------------------- ERROR HANDLING
import Error404 from "./error/Error404";
// ------------------------------------------------------- ERROR HANDLING

import { Configs, dealWithAPIReturnedData } from "../Toolbox";
//import Forms from "../components/Forms";

/**
 * @description
 * Para apresentação do "ambiente de trabalho" da App da base de todas as
 * páginas
 *
 * @param {*} props
 */
const DashboardView = (props) => {
  const { t, i18n } = useTranslation();
  const [lang, setLang] = useState();
  const [stickyFMOptions, setSFMOptions] = useState();

  const [wClick, setWClick] = useState(null);

  // o component AppMenu executa um pedido sobre a API p obtencao dos
  // componentes que asseguram o menu sendo que estes são necessários
  // tb no Footer, no sentido de evitar novo pedido destes dados sobre a API
  // neste componente, obtem-se estes a partir do MENU passando-os via DASHBOARD
  // para o FOOTER
  const [navigation, setNavigation] = useState();

  const webserver = props.webserver ? props.webserver : null;

  /// campos para o FORM de pedido de orçamento(s)
  let fields = [
    Object.assign({ required: "required" }, Configs.form_fields.name),
    Object.assign({ required: "required" }, Configs.form_fields.email),
    Object.assign({ required: "required" }, Configs.form_fields.mobile),
    Object.assign({ required: "required" }, Configs.form_fields.remarks),
    Object.assign({ required: "required" }, Configs.form_fields.rgpdconsent),
  ];

  // torna todos os campos obrigatórios

  // actualiza info para a form de budget...
  // o campo remarks neste caso em particular não é remarks é Comments
  // actualiza essa info
  if (fields[3]) {
    fields[3]["data-i18n-key"] = "comments";
  }

  // custumiza o campo relacionado com o RGPD
  if (fields[4]) {
    fields[4].offspring[0].text = t("forms").rgpdconsent[1];
  }

  /**
   * @description
   * Equivalente ao componentDidMount / componentDidUpdate
   *
   */
  useEffect(() => {
    // Actualiza o idioma usado na app... esta var poderá servir como
    // Lifting Up State e por esta via implicar o render dos components
    // child. Neste momento julga-se últil para obter os conteúdos
    // dinâmicos a partir de uma API ou BO
    setLang(i18n.language);

    //window.scrollTo({ top: 0, behavior: "smooth" });
  }, [lang, setLang, navigation, setNavigation, i18n, wClick, setWClick]);

  /*  window.onclick = (e) => {
    setWClick(e);
  }; */

  return (
    <Router>
      <div className="wrapper row">
        {
          /*<Helmet>
          <title>Prilux Development</title>
          <meta name="description" content="WebSite description" />
          <meta property="og:title" content="Prilux Release 7.01" />
          <meta property="og:image" content="Your path/to/image.jpg" />
        </Helmet>*/
          //
          //
          // definição dos níveis de visibilidade do stickybar...
        }
        <Route
          exact
          path={[
            `/:lang([a-z]{2})/${t("menu").services[1]}`,
            `/:lang([a-z]{2})/${t("menu").services[1]}/:optionId/:optionSlug`,
            `/:lang([a-z]{2})/${t("menu").about[1]}/:optionId/:optionSlug`,
            `/:lang([a-z]{2})/${
              t("menu").automatisms[1]
            }/:optionId/:optionSlug`,
            `/:lang([a-z]{2})/${t("menu").news[1]}/:optionId/:optionSlug`,
            `/:lang([a-z]{2})/${t("menu").projects[1]}/:optionId/:optionSlug`,
            `/:lang([a-z]{2})/${t("menu").ghouse[1]}-${
              t("menu").services[1]
            }/:optionId/:optionSlug`,
            `/:lang([a-z]{2})/${t("menu").ghouse[1]}-${
              t("menu").services[1]
            }/:optionId/:optionSlug/:familyId/:familySlug/`,

            `/:lang([a-z]{2})/${t("menu").products[1]}/:optionId/:optionSlug`,
            `/:lang([a-z]{2})/${
              t("menu").products[1]
            }/:optionId/:optionSlug/:familyId/:familySlug/`,
            `/:lang([a-z]{2})/${
              t("menu").ghouse[1]
            }/:optionId/:optionSlug/:familyId/:familySlug/`,
          ]}
          render={(props) => (
            <StickyFilterMenu
              {...props}
              fclass="sticky-fm"
              stickyFMOptions={stickyFMOptions}
            />
          )}
        />

        {/* <StickyFilterMenu
          fclass="sticky-fm"
          stickyFMOptions={stickyFMOptions}
        /> */}

        <Route
          exact
          path={[
            `/:lang([a-z]{2})`,
            /*  `/:lang([a-z]{2})/(${t("menu").products[1]}|${
              t("menu").ghouse[1]
            })`, */
            `/:lang([a-z]{2})/${t("menu").ghouse[1]}/:optionId/:optionSlug`,
            `/:lang([a-z]{2})/${
              t("menu").ghouse[1]
            }/:optionId/:optionSlug/:familyId?/:familySlug?`,
            `/:lang([a-z]{2})/${
              t("menu").products[1]
            }/:optionId/:optionSlug/:familyId?/:familySlug?`,
            `/:lang([a-z]{2})/${
              t("menu").suporte_ghouse[1]
            }/:optionId/:optionSlug/:familyId?/:familySlug?`,
          ]}
          render={(props) => (
            <BudgetForm {...props} wClicked={wClick} fields={fields} />
          )}
        />
        {/* <BudgetForm fields={fields} /> */}
        <AppMenu
          use="stickybar"
          navData={setNavigation}
          lang={lang}
          {...props}
          wClicked={wClick}
        />
        <main style={{ width: "100%" }}>
          <Switch>
            <Route
              exact
              path={`/:lang([a-z]{2})`}
              render={(props) => <Home {...props} />}
            />

            <Route
              exact
              path={`/:lang([a-z]{2})/${t("menu").downloads[1]}`}
              render={(props) => <ProjectsAndDownloads {...props} />}
            />
            <Route
              exact
              path={`/:lang([a-z]{2})/contactos`}
              render={(props) => <Contacts {...props} />}
            />
            <Route
              exact
              path={`/:lang([a-z]{2})/${t("menu").privacy[1]}`}
              render={(props) => <RGPD {...props} />}
            />

            <Route
              path={`/:lang([a-z]{2})/${
                t("menu").about[1]
              }/:optionId/:optionSlug`}
              render={(props) => (
                <About
                  setSFMOptions={setSFMOptions}
                  navData={navigation}
                  {...props}
                />
              )}
            />

            <Route
              exact
              path={`/:lang([a-z]{2})/${t("menu").about[1]}`}
              render={(props) => <About {...props} />}
            />

            <Route
              exact
              path={`/:lang([a-z]{2})/${
                t("menu").news[1]
              }/:optionId/:optionSlug`}
              render={(props) => (
                <NewsDetailView
                  setSFMOptions={setSFMOptions}
                  navData={navigation}
                  {...props}
                />
              )}
            />

            <Route
              exact
              path={[
                `/:lang([a-z]{2})/${t("menu").services[1]}`,
                `/:lang([a-z]{2})/${
                  t("menu").services[1]
                }/:optionId/:optionSlug`,
              ]}
              render={(props) => (
                <ServicesView
                  setSFMOptions={setSFMOptions}
                  navData={navigation}
                  {...props}
                />
              )}
            />

            <Route
              exact
              path={[
                `/:lang([a-z]{2})/${
                  t("menu").suporte_ghouse[1]
                }/:optionId/:optionSlug/:familyId?/:familySlug?`,
                `/:lang([a-z]{2})/${t("menu").ghouse[1]}/:optionId/:optionSlug`, // click nível 1 => categoria (MR2, pri-multi) // click nível 2 => família (abraçadeiras, asnas, etc...)*/
                `/:lang([a-z]{2})/${
                  t("menu").product_detalhe[1]
                }/:optionId/:optionSlug`,
              ]}
              render={(props) => <ProductDetailView {...props} />}
            />

            {/** Listagem de produtos tipo estufas, estufas/serviços **/}
            <Route
              exact
              path={[
                `/:lang([a-z]{2})/${t("menu").ghouse[1]}`,
                `/:lang([a-z]{2})/${t("menu").ghouse[1]}/:optionId/:optionSlug`,
                `/:lang([a-z]{2})/${
                  t("menu").ghouse[1]
                }/:optionId/:optionSlug/:familyId?/:familySlug?`,
                /* `/:lang([a-z]{2})/${
                  t("menu").ghouse[1]
                }/:optionId/:optionSlug/:familyId/:familySlug/#:familyId`, */
              ]}
              render={(props) => (
                <GreenHouseListView
                  setSFMOptions={setSFMOptions}
                  navData={navigation}
                  {...props}
                />
              )}
            />
            {/** Estufas em detalhe, Estufas/Serviços em detalhe */}
            <Route
              exact
              path={[
                `/:lang([a-z]{2})/${t("menu").ghouse[1]}-${
                  t("menu").services[1]
                }/:optionId/:optionSlug`,
                `/:lang([a-z]{2})/${t("menu").ghouse[1]}-${
                  t("menu").services[1]
                }/:optionId/:optionSlug/:familyId/:familySlug/`,
              ]}
              render={(props) => (
                <GreenHouseServiceDetailView
                  setSFMOptions={setSFMOptions}
                  navData={navigation}
                  {...props}
                />
              )}
            />

            <Route
              exact
              path={`/:lang([a-z]{2})/${
                t("menu").automatisms[1]
              }/:optionId/:optionSlug`}
              render={(props) => (
                <AutomatismsView
                  setSFMOptions={setSFMOptions}
                  navData={navigation}
                  {...props}
                />
              )}
            />
            {/** Listagem de produtos **/}
            <Route
              exact
              path={[
                `/:lang([a-z]{2})/${t("menu").products[1]}`,
                `/:lang([a-z]{2})/${
                  t("menu").products[1]
                }/:optionId/:optionSlug`,
                `/:lang([a-z]{2})/${
                  t("menu").products[1]
                }/:optionId/:optionSlug/:familyId/:familySlug/`,
              ]}
              render={(props) => (
                <ProductListlView
                  setSFMOptions={setSFMOptions}
                  navData={navigation}
                  {...props}
                />
              )}
            />
            {/* LISTA DE PROJECTOS OU DE DOWNLOADS */}
            <Route
              exact
              path={`/:lang([a-z]{2})/${t("menu").projects[1]}`}
              render={(props) => <ProjectsAndDownloads {...props} />}
            />
            {/* DETALHE DE PROJECTOS */}
            <Route
              exact
              path={`/:lang([a-z]{2})/${
                t("menu").projects[1]
              }/:optionId/:optionSlug`}
              render={(props) => (
                <ProjectDetailView
                  setSFMOptions={setSFMOptions}
                  navData={navigation}
                  {...props}
                />
              )}
            />

            {/* PESQUISA DE PRODUTO */}
            <Route
              exact
              path={`/:lang([a-z]{2})/${t("search")}/q=:searchText`}
              render={(props) => <SearchProductView {...props} />}
            />

            {/* LOJA ONLINE -- HOME */}
            <Route
              exact
              path={[
                `/:lang([a-z]{2})/${t("menu").store[1]}`,
                `/:lang([a-z]{2})/${t("menu").store[1]}/:optionId/:optionSlug`,
                `/:lang([a-z]{2})/${
                  t("menu").store[1]
                }/:optionId/:optionSlug/:familyId/:familySlug`,
              ]}
              render={(props) => <StoreHomeView {...props} />}
            />

            {/* PROJETOS FINANCIADOS */}
            <Route
              exact
              path={`/:lang([a-z]{2})/${t("menu").funded_projects[1]}`}
              render={(props) => <FundedProjectsView {...props} />}
            />

            {/* 
            --------------------- 
            404
            */}
            <Route path="*" render={(props) => <Error404 {...props} />} />
            {/* <Route path="*" render={(props) => <Redirect to={`/${lang}`} />} /> */}
          </Switch>
        </main>
      </div>
      <AppFooter className="app-footer" navData={navigation} />
    </Router>
  );
};

export default DashboardView;

export const StickyBar = () => {};
